import Logo from "@/components/Logo";

/**
 * SlideShell: full-screen slide wrapper with overhead logo header
 * and slide number badge. Each slide uses this shell.
 */
export const SlideShell = ({
  id,
  index,
  total,
  variant = "dark", // "dark" -> logo uses dark text on light bg
  className = "",
  children,
  hideHeader = false,
}) => {
  return (
    <section
      id={`slide-${id}`}
      data-testid={`slide-${id}`}
      className={`slide ${className}`}
    >
      {!hideHeader && (
        <header className="absolute top-0 left-0 right-0 z-30 px-6 md:px-12 py-5 md:py-6 flex items-center justify-between">
          <Logo variant={variant} />
          <div
            className={`hidden md:flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] font-semibold ${
              variant === "light" ? "text-white/70" : "text-zinc-500"
            }`}
            data-testid={`slide-badge-${id}`}
          >
            <span>
              {String(index + 1).padStart(2, "0")}
              <span className={variant === "light" ? "text-white/30" : "text-zinc-300"}>
                {" / "}
              </span>
              {String(total).padStart(2, "0")}
            </span>
          </div>
        </header>
      )}
      {children}
    </section>
  );
};

export default SlideShell;
